import { doc, setDoc, getDocs, collection, query, orderBy, limit, where, onSnapshot } from 'firebase/firestore';
import { db } from './firebaseService';

export interface FeedbackItem {
  id: string;
  userId: string;
  query: string;
  response: string;
  rating: 'up' | 'down';
  timestamp: number;
  modelUsed?: string;
}

/**
 * Log user feedback for an AI response
 */
export const logFeedback = async (feedback: FeedbackItem): Promise<void> => {
  try {
    await setDoc(doc(db, 'feedback', feedback.id), feedback);
    console.log('Feedback logged:', feedback.id);
  } catch (error) {
    console.error('Error logging feedback:', error);
  }
};

/**
 * Listen to feedback (Admin)
 */
export const listenToFeedback = (callback: (feedback: FeedbackItem[]) => void) => {
  const q = query(collection(db, 'feedback'), orderBy('timestamp', 'desc'));
  return onSnapshot(q, (snapshot) => {
    const feedback = snapshot.docs.map(doc => doc.data() as FeedbackItem);
    callback(feedback);
  });
};

/**
 * Get all feedback (for Admin Dashboard)
 */
export const getAllFeedback = async (): Promise<FeedbackItem[]> => {
  try {
    const q = query(collection(db, 'feedback'), orderBy('timestamp', 'desc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => doc.data() as FeedbackItem);
  } catch (error) {
    console.error('Error getting feedback:', error);
    return [];
  }
};

/**
 * Get high-quality examples for Few-Shot Prompting (RAG)
 * Fetches positive feedback items to use as context
 */
export const getGoodExamples = async (limitCount: number = 3): Promise<FeedbackItem[]> => {
  try {
    const q = query(
      collection(db, 'feedback'), 
      where('rating', '==', 'up'),
      orderBy('timestamp', 'desc'),
      limit(limitCount)
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => doc.data() as FeedbackItem);
  } catch (error) {
    console.error('Error getting good examples:', error);
    return [];
  }
};
